import registerUrlTokensAsync from './registerUrlTokensAsync';
import { appConfig } from 'cd-eft/config/AppConfig';
const refererUrlTokens = appConfig.esriIdentityManager.refererUrlTokens;

async function configureRefererUrlTokensAsync(refererUrl: string) {
  const refererProfile = refererUrlTokens.find((item) => {
    return refererUrl.startsWith(item.refererStartsWith);
  });
  if (refererProfile) {
    const urlTokens = refererProfile.urlTokens;
    await registerUrlTokensAsync(urlTokens);
  }
}

export default configureRefererUrlTokensAsync;
